import './App.scss';
import { FC } from 'react';
import AppRoutes from './routes/AppRoutes';
import BackToTop from './components/BackToTop/BackToTopComponent';
import { useLoadTrackingScript } from './hooks/useLoadTrackingScript';
import { useWidgetLoader } from './hooks/useWidgetLoader';
import ToastContainerComponent from './components/UI/ToastComponent/ToastContainerComponent/ToastContainerComponent';
import useScrollRestoration from './hooks/useScrollRestoration';
import { AuthActions } from './redux/AuthActions';
import { useTokenRefresher } from './hooks/useTokenRefresher';
import { useAuthCallback } from './hooks/useAuthCallbacks';
import { useAppDispatch } from './redux/store';
import useHasData from './hooks/useHasData';

export const App: FC = () => {
	const dispatch = useAppDispatch();
	const setIsRefreshingToken = (isRefreshing: boolean) => {
		dispatch(AuthActions.isRefreshingToken(isRefreshing));
	};
	useWidgetLoader();
	useLoadTrackingScript();
	useScrollRestoration();
	useTokenRefresher(setIsRefreshingToken);
	useAuthCallback();
	useHasData();

	return (
		<div data-testid='app'>
			<ToastContainerComponent />
			<BackToTop />
			<AppRoutes />
		</div>
	);
};

export default App;
